import DataProvider from "../DataProvider";

/**
 * Resets the secret for a given webhook.
 * @param {string} webhookId The ID of the webhook to reset the secret for.
 * @returns {Promise} A promise that resolves when the secret has been reset.
 */
async function resetWebhookSecret(webhookId) {
  const id = parseInt(webhookId);
  const response = await fetch(`/api/webhooks/${webhookId}`, {
    method: "PUT",
    body: JSON.stringify({ id, resetSecret: true }),
    headers: {
      "content-type": "application/json",
    },
  });
  const data = await response.json();
  return data.data;
}

async function resetWebhookSignature(webhookId) {
  const id = parseInt(webhookId);
  const data = await DataProvider.update("webhooks", {
    id,
    data: { resetSignature: true },
  });
  return data.data;
}

export { resetWebhookSecret, resetWebhookSignature };
